import { Alert, AlertTitle, Container } from '@mui/material';
import React from 'react';

import useAuth from 'hooks/useAuth';
import { AppRole, hasAnyRole } from 'utils/roles';

interface RoleGuardProps {
    accessibleRoles: AppRole[];
}

const RoleGuard: React.FunctionComponent<RoleGuardProps> = ({ accessibleRoles, children }) => {
    const { profile } = useAuth();
    const hasAccess = hasAnyRole(profile?.group, accessibleRoles);

    if (hasAccess) {
        return <>{children}</>;
    }

    return (
        <Container>
            <Alert severity='error'>
                <AlertTitle>Permission Denied</AlertTitle>
                You do not have permission to access this page
            </Alert>
        </Container>
    );

    // if (!accessibleRoles.includes(profile?.group)) {
    //     return (
    //         <Container>
    //             <Alert severity='error'>
    //                 <AlertTitle>Permission Denied</AlertTitle>
    //                 You do not have permission to access this page
    //             </Alert>
    //         </Container>
    //     );
    // }

    // return <>{children}</>;
};

export default RoleGuard;
